import React from "react";
/*
  Renders a tooltip for the user
    props:
    state:
*/

class Tooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.visible = false;
    this.cachedTooltip = undefined;
  }

  componentDidUpdate() {
    if (!this.visible && this.props.tooltip) {
      this.visible = true;
      this.cachedTooltip = this.props.tooltip;
      $(".tooltip")
        .hide()
        .fadeIn();
      this.forceUpdate();
    } else if (this.visible && !this.props.tooltip) {
      this.cachedTooltip = undefined;
      this.visible = false;
    }
  }

  render() {
    let tooltipStyle;
    if (this.cachedTooltip) {
      let top, left;

      let minLeft = this.cachedTooltip.minLeft || 6;
      let minTop = this.cachedTooltip.minTop || 6;

      // If location is defined, determine left/top coordinates
      // Note that either a location or BOTH left/right coordinates should be defined
      if (this.cachedTooltip.location) {
        let message = this.cachedTooltip.message || "";
        let objectTop = this.cachedTooltip.object.offset().top;
        let objectLeft = this.cachedTooltip.object.offset().left;
        if (this.props.absolute) {
          objectTop = this.cachedTooltip.object.position().top;
          objectLeft = this.cachedTooltip.object.position().left;
          minLeft = -this.cachedTooltip.object.parent().offset().left + 6;
          minTop = -this.cachedTooltip.object.parent().offset().top + 6;
        }
        switch (this.cachedTooltip.location) {
          case "left":
            top = Math.max(
              minTop,
              Math.min(
                objectTop + this.cachedTooltip.object.height() / 2 - 14,
                $(window).height() - 28 - 6
              )
            );
            left = Math.max(
              minLeft,
              Math.min(
                objectLeft -
                  (message.size().width + 32) / 2 -
                  8,
                $(window).width() -
                  (message.size().width + 32) -
                  6
              )
            );
            break;
          case "right":
            top = Math.max(
              minTop,
              Math.min(
                objectTop + this.cachedTooltip.object.height() / 2 - 14,
                $(window).height() - 28 - 6
              )
            );
            left = Math.max(
              minLeft,
              Math.min(
                objectLeft + this.cachedTooltip.object.width() + 8,
                $(window).width() -
                  (message.size().width + 32) -
                  6
              )
            );
            break;
          case "top":
            top = Math.max(
              minTop,
              Math.min(objectTop - 28 - 6, $(window).height() - 28 - 6)
            );
            left = Math.max(
              minLeft,
              Math.min(
                objectLeft +
                  this.cachedTooltip.object.width() / 2 -
                  (message.size().width + 16) / 2,
                $(window).width() -
                  (message.size().width + 16) -
                  6
              )
            );
            break;
          case "low-top":
            top = Math.max(
              minTop,
              Math.min(objectTop - 18 - 6, $(window).height() - 18 - 6)
            );
            left = Math.max(
              minLeft,
              Math.min(
                objectLeft +
                  this.cachedTooltip.object.width() / 2 -
                  (message.size().width + 22) / 2,
                $(window).width() - message.size().width - 6
              )
            );
            break;
          case "bottom":
            top = Math.max(
              minTop,
              Math.min(
                objectTop + this.cachedTooltip.object.height() + 6,
                $(window).height() - 28 - 6
              )
            );
            left = Math.max(
              minLeft,
              Math.min(
                objectLeft +
                  this.cachedTooltip.object.width() / 2 -
                  (message.size().width + 16) / 2,
                $(window).width() -
                  (message.size().width + 16) -
                  6
              )
            );
            break;
          default:
            break;
        }
      }

      // If absolute numbers defined, use those instead of calculating
      if (this.cachedTooltip.left) {
        left = this.cachedTooltip.left;
      }
      if (this.cachedTooltip.top) {
        top = this.cachedTooltip.top;
      }

      tooltipStyle = { top: top + "px", left: left + "px" };
      if (this.props.absolute) {
        tooltipStyle.position = "absolute";
      }
    }
    if (this.props.tooltip) {
      return (
        <div className="tooltip" style={tooltipStyle} aria-hidden="true">
          {this.cachedTooltip && toHTML(this.cachedTooltip.message || "")}
        </div>
      );
    } else {
      return <div />;
    }
  }
}

var TooltipMixin = {
  // Set the tooltip
  showTooltip: function(object, message, location, minLeft, minTop, left, top) {
    var self = this;

    // If tooltip remove it
    this.removeTooltip();

    // give enough time to reset before setting state
    setTimeout(function() {
      self.setState({
        tooltip: {
          object: object,
          message: message,
          location: location,
          minLeft: minLeft,
          minTop: minTop,
          left: left,
          top: top
        }
      });
    }, 0);
  },

  removeTooltip: function() {
    this.setState({ tooltip: undefined });
  },

  // Add the tooltip
  _addTooltipEvent: function(e) {
    var targetObject = $(e.currentTarget);
    if ($(e.currentTarget).data("target-dom-id")) {
      targetObject = $("#" + $(e.currentTarget).data("target-dom-id"));
    }
    this.showTooltip(
      targetObject,
      $(e.currentTarget).data("tooltip"),
      $(e.currentTarget).data("tooltip-location"),
      $(e.currentTarget).data("tooltip-min-left"),
      $(e.currentTarget).data("tooltip-min-top"),
      $(e.currentTarget).data("tooltip-left"),
      $(e.currentTarget).data("tooltip-top")
    );
  },

  // Remove the tooltip
  _removeTooltipEvent: function() {
    this.removeTooltip();
  }
};

export { Tooltip, TooltipMixin };
